import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CartHeader from "../Cart/Header";

import PaymentRing from "../../../Assets/PaymentRing.png";

import GPayIcon from "../../../Assets/iconGPay.png";
import PaytmIcon from "../../../Assets/iconPaytm.png";
import PhonePeIcon from "../../../Assets/iconPhonepe.png";
import BhimIcon from "../../../Assets/IconBhima.png";

import "./QRScreen.css";

export default function PaymentScreen() {
  const location = useLocation();
  const navigate = useNavigate();

  const { backendOrderId, totalAmount, qrBase64 } = location.state || {};

  const [timeLeft, setTimeLeft] = useState(60);

  // Redirect if data missing
  useEffect(() => {
    if (!backendOrderId || !totalAmount || !qrBase64) {
      console.log("❌ Missing order data, redirecting home");
      navigate("/");
    }
  }, [backendOrderId, totalAmount, qrBase64, navigate]);

  // Countdown
  useEffect(() => {
    if (timeLeft <= 0) {
      console.log("⏳ Payment timeout");
      navigate("/user");
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, navigate]);

  // POLLING PAYMENT STATUS
  useEffect(() => {
    if (!backendOrderId) return;

    console.log("🔁 Starting payment polling...");

    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `https://fliplyn-b-c.fly.dev/orders/${backendOrderId}`
        );

        const data = await res.json();

        console.log("📡 Payment status from backend:", data.payment_status);

        if (data.payment_status === "PAID") {
          console.log("✅ Payment SUCCESS - navigating");
          clearInterval(interval);
          navigate("/payment-success", { state: data });
        }

        if (data.payment_status === "FAILED") {
          console.log("❌ Payment FAILED - navigating");
          clearInterval(interval);
          navigate("/user", { state: data });
        }
      } catch (error) {
        console.error("🚨 Polling error:", error);
      }
    }, 3000);

    return () => {
      console.log("🛑 Stopping polling");
      clearInterval(interval);
    };
  }, [backendOrderId, navigate]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  return (
    <div className="ps-page">
      <CartHeader />

      <main className="ps-container">
        <h1 className="ps-title">Scan & Pay via UPI</h1>
        <p className="ps-subtitle">
          Order #{backendOrderId} – ₹{totalAmount}
        </p>

        <div className="ps-card">
          <div className="ps-ring-wrapper">
            <img src={PaymentRing} alt="Ring" className="ps-ring" />

            <img
              src={`data:image/png;base64,${qrBase64}`}
              alt="QR"
              className="ps-qr"
            />
          </div>

          <h2 className="ps-amount">₹{totalAmount}</h2>

          <p className="ps-desc">
            Scan this QR with GPay/PhonePe/Paytm
            <br />
            Payment auto cancels in{" "}
            <span className="ps-timer">{formatTime(timeLeft)}</span>
          </p>

          <div className="ps-app-row">
            <img src={GPayIcon} className="ps-app-icon" alt="Google Pay" />
            <img src={PaytmIcon} className="ps-app-icon" alt="Paytm" />
            <img src={PhonePeIcon} className="ps-app-icon" alt="PhonePe" />
            <img src={BhimIcon} className="ps-app-icon bhim" alt="BHIM" />
          </div>
        </div>
      </main>

      <button className="ps-home-btn" onClick={() => navigate("/")}>
        Home
      </button>
    </div>
  );
}
